export enum ChatMessageType {
    ConnectionState = 'connectionState',
    VisualState = 'visualState',
    Command = 'command',
    QrCode = 'qrcode',
    Text = 'text',
    Info = 'info',
    Popup = 'popup',
    Buttons = 'buttons',
    ResponseProgress = 'responseProgress',
    Reconnect = 'reconnect',
}